import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';//,, PreloadAllModules
import { DataResolverService } from './resolver/data-resolver.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'app',
    loadChildren: () => import('./pages/tabs/tabs.module').then( m => m.TabsPageModule)
  },
  {
    path: 'contact',
    loadChildren: () => import('./pages/contact/contact.module').then( m => m.ContactPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'singup',
    loadChildren: () => import('./pages/singup/singup.module').then( m => m.SingupPageModule)
  },
  { 
    path: 'chat', 
    resolve: {
      special: DataResolverService
    },
    loadChildren: () => import('./pages/chats/chat/chat.module').then( m => m.ChatPageModule)
  },
  { path: 'transactions', loadChildren: () => import('./pages/transactions/transactions.module').then( m => m.TransactionsPageModule) },
  { path: 'services', loadChildren: () => import('./pages/services/services.module').then( m => m.ServicesPageModule) },
  { path: 'quick-pay', loadChildren: () => import('./pages/quick-pay/quick-pay.module').then( m => m.QuickPayPageModule) },
  { path: 'cardv', loadChildren: () => import('./pages/cardv/cardv.module').then( m => m.CardvPageModule) },
  { path: 'chats', loadChildren: () => import('./pages/chats/chats.module').then( m => m.ChatsPageModule) },
  { path: 'notify', loadChildren: () => import('./pages/notify/notify.module').then( m => m.NotifyPageModule) },
  { path: 'movs', loadChildren: () => import('./pages/movs/movs.module').then( m => m.MovsPageModule) },
  { path: 'bill', loadChildren: () => import('./pages/bill/bill.module').then( m => m.BillPageModule) },
  { path: 'friend', loadChildren: () => import('./pages/friend/friend.module').then( m => m.FriendPageModule) },
  { path: 'profile', loadChildren: () => import('./pages/profile/profile.module').then( m => m.ProfilePageModule) },
  { path: 'recharge', loadChildren: () => import('./pages/recharge/recharge.module').then( m => m.RechargePageModule) },
  { path: 'pocket', loadChildren: () => import('./pages/pocket/pocket.module').then( m => m.PocketPageModule) },
  { path: 'time', loadChildren: () => import( './pages/time/time.module').then( m => m.TimePageModule) },
  { path: 'thrift', loadChildren: () => import('./pages/thrift/thrift.module').then( m => m.ThriftPageModule) },
  { path: 'member', loadChildren: () => import('./pages/member/member.module').then( m => m.MemberPageModule) },
  { path: 'config', loadChildren: () => import('./pages/config/config.module').then( m => m.ConfigPageModule) },
  { path: 'change-password', loadChildren: () => import('./pages/change-password/change-password.module').then( m => m.ChangePasswordPageModule) },
  { path: 'verific-account-user', loadChildren: () => import('./pages/verific-account-user/verific-account-user.module').then( m => m.VerificAccountUserPageModule) },
  { path: 'QrPage', loadChildren: () => import('./pages/qr/qr.module').then( m => m.QrPageModule) },
  {
    path: 'recovery',
    loadChildren: () => import('./pages/recovery/recovery.module').then( m => m.RecoveryPageModule)
  },
  {
    path: 'help',
    loadChildren: () => import('./pages/help/help.module').then( m => m.HelpPageModule)
  },
  {
    path: 'help-chat',
    loadChildren: () => import('./pages/help-chat/help-chat.module').then( m => m.HelpChatPageModule)
  },
  {
    path: 'p2p',
    loadChildren: () => import('./pages/p2p/p2p.module').then( m => m.P2pPageModule)
  },
  {
    path: 'order',
    loadChildren: () => import('./pages/p2p/orders/order/order.module').then( m => m.OrderPageModule)
  },
  {
    path: 'qr',
    loadChildren: () => import('./modals/qr/qr.module').then( m => m.QrPageModule)
  }






];
@NgModule({
  imports: [ RouterModule.forRoot(routes)], //, { preloadingStrategy: PreloadAllModules }
  exports: [RouterModule]
})
export class AppRoutingModule {}
